import { Pipe, PipeTransform } from '@angular/core';
import { Workshop } from 'src/models/workshop';
@Pipe({
    name: 'filterWorkshops',
    standalone: false
})
  export class FilterWorkshopsPipe implements PipeTransform {
    transform(items:(Workshop[] | null), workshopName: string, cityName:string, adress:string, chiefOfWorkshopName:string, brandName:string): Workshop[] {
        if (!items) {
            return [];
          }
          if (!workshopName && !cityName && !adress && !chiefOfWorkshopName && !brandName) {
            return items;
          }

          //  change de words a lower case example ASD = asd
          workshopName = workshopName.toLowerCase();
          cityName = cityName.toLowerCase();
          adress = adress.toLowerCase();
          chiefOfWorkshopName= chiefOfWorkshopName.toLowerCase()
          brandName = brandName.toLowerCase()
          
          
          return items.filter(item => {
            // Filter the objects by the workshop name and city name
            const nameMatch = item.workshopName.toLowerCase().includes(workshopName);
            const cityMatch = item.cityName?.toLowerCase().includes(cityName);
            const adressMatch= item.address.toLowerCase().includes(adress);
            const chiefOfWorkshopMatch= item.chiefOfWorkshop!.toLowerCase().includes(chiefOfWorkshopName);
            const brandNameMatch= item.brands.find((item) => item.brandName.toLowerCase().includes(brandName)&&  item.isActive === true )!== undefined
            return nameMatch && cityMatch && adressMatch && chiefOfWorkshopMatch && brandNameMatch;
          });
      
    }
  }